@if(hewStock && hewStock.length > 0){

<div class="stock-row title">
  <span class="title">
    {{"BATCH NUMBER"|translate}}
  </span>
</div>

@for( stock of hewStock;let i = $index; track $index){

<div class="stock-accordion accordion-item">
  <button class="accordion-button collapsed stock-row" type="button" data-bs-toggle="collapse" aria-expanded="false"
    [attr.aria-controls]="'collapse-'+i" appAccordion>
    {{stock.batchNumber}}
    <div class="bfs">
      @if(stock.isBookedForSale){
      {{"BOOKED FOR SALE"|translate}}
      }
    </div>
  </button>
  <div [id]="'collapse-'+i" class="accordion-collapse collapse">
    <div class="accordion-body">
      <div class="stock-row">
        <span>{{"Company Current Location"|translate}}</span>
        <span>{{stock.currentCompanyDescription}}</span>
      </div>
      <div class="stock-row">
        <span>{{"Current Location Description"|translate}}</span>
        <span>{{stock.currentStoreDescription}}</span>
      </div>
      <!-- @if(stock.isBookedForSale){
      <div class="stock-row">
        <span>{{"Status"|translate}}</span>
        <span>{{"Booked For Sales"|translate}}</span>
      </div>
      } -->
    </div>
  </div>
</div>

}

}@else {

<app-placeholder [message]="'No stock Available'|translate"></app-placeholder>

}
